export const OPTIONS = {
  roles: [
    'Marketing Director / VP',
    'Marketing Manager',
    'Growth Marketer',
    'Media Buyer',
    'Agency Owner',
    'Sales Director',
    'Operations / RevOps',
    'Founder / CEO',
    'Other',
  ],
  industries: [
    'Automotive',
    'Real Estate',
    'Financial Services',
    'Insurance',
    'Education',
    'Health & Wellness',
    'Ecommerce / Retail',
    'SaaS / Tech',
    'Legal Services',
    'Travel & Hospitality',
    'Home Services (HVAC, Plumbing, Roofing, etc.)',
    'Marketing & Advertising Agencies',
    'Events & Entertainment',
    'Staffing & Recruitment',
    'Telecommunications',
    'Nonprofit / Charity',
    'Manufacturing / Industrial',
    'Other',
  ],
  companySizes: ['1–10', '11–50', '51–200', '201–500', '501–1,000', '1,000+'],
  countries: [
    'United States',
    'Afghanistan',
    'Albania',
    'Algeria',
    'Andorra',
    'Angola',
    'Antigua and Barbuda',
    'Argentina',
    'Armenia',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bhutan',
    'Bolivia',
    'Bosnia and Herzegovina',
    'Botswana',
    'Brazil',
    'Brunei',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cabo Verde',
    'Cambodia',
    'Cameroon',
    'Canada',
    'Central African Republic',
    'Chad',
    'Chile',
    'China',
    'Colombia',
    'Comoros',
    'Congo',
    'Costa Rica',
    'Croatia',
    'Cuba',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Eritrea',
    'Estonia',
    'Eswatini',
    'Ethiopia',
    'Fiji',
    'Finland',
    'France',
    'Gabon',
    'Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Greece',
    'Grenada',
    'Guatemala',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Honduras',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iran',
    'Iraq',
    'Ireland',
    'Israel',
    'Italy',
    'Jamaica',
    'Japan',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kiribati',
    'Korea, North',
    'Korea, South',
    'Kosovo',
    'Kuwait',
    'Kyrgyzstan',
    'Laos',
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Marshall Islands',
    'Mauritania',
    'Mauritius',
    'Mexico',
    'Micronesia',
    'Moldova',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Morocco',
    'Mozambique',
    'Myanmar',
    'Namibia',
    'Nauru',
    'Nepal',
    'Netherlands',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'North Macedonia',
    'Norway',
    'Oman',
    'Pakistan',
    'Palau',
    'Palestine',
    'Panama',
    'Papua New Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Poland',
    'Portugal',
    'Qatar',
    'Romania',
    'Russia',
    'Rwanda',
    'Saint Kitts and Nevis',
    'Saint Lucia',
    'Saint Vincent and the Grenadines',
    'Samoa',
    'San Marino',
    'Sao Tome and Principe',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'Solomon Islands',
    'Somalia',
    'South Africa',
    'South Sudan',
    'Spain',
    'Sri Lanka',
    'Sudan',
    'Suriname',
    'Sweden',
    'Switzerland',
    'Syria',
    'Taiwan',
    'Tajikistan',
    'Tanzania',
    'Thailand',
    'Timor-Leste',
    'Togo',
    'Tonga',
    'Trinidad and Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Tuvalu',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom',
    'Uruguay',
    'Uzbekistan',
    'Vanuatu',
    'Vatican City',
    'Venezuela',
    'Vietnam',
    'Yemen',
    'Zambia',
    'Zimbabwe',
  ],
  adPlatforms: [
    'Meta Ads (Facebook/Instagram)',
    'Google Ads (Search, Display, YouTube)',
    'TikTok Ads',
    'LinkedIn Ads',
    'Snapchat Ads',
    'Pinterest Ads',
    'Amazon Ads',
    'Native Ads (Taboola/Outbrain)',
    'Programmatic Display',
    'Buy leads from 3rd-party vendors',
    'Organic (SEO, content, social)',
    'Referral / Word-of-mouth',
    'Other',
  ],
  adSpends: [
    'Less than $1,000',
    '$1,000–$5,000',
    '$5,001–$25,000',
    '$25,001–$100,000',
    'Over $100,000',
  ],
  crmTools: [
    'Salesforce',
    'HubSpot',
    'Zoho',
    'Pipedrive',
    'Keap / Infusionsoft',
    'ActiveCampaign',
    'Mailchimp',
    'None',
    'Other',
  ],
  primaryGoals: [
    'Automate lead data transfer',
    'Improve lead response time',
    'Increase conversion rates',
    'Reduce manual data entry',
    'Connect multiple platforms',
    'Track customer journey',
    'Optimize ad campaigns',
  ],
  secondaryGoals: [
    'Automate lead data transfer',
    'Improve lead response time',
    'Increase conversion rates',
    'Reduce manual data entry',
    'Connect multiple platforms',
    'Track customer journey',
    'Optimize ad campaigns',
  ],
} as const
